import {createFileRoute, stripSearchParams} from '@tanstack/react-router'
import {type} from 'arktype'

import {fallbackToDefault} from '@/utils/schema/fallback'

const DEFAULT_VALUES = {
  page: 1,
}

const bookmarksSearchSchema = type({
  page: fallbackToDefault(type('number > 0'), DEFAULT_VALUES.page),
})

export const Route = createFileRoute('/bookmarks')({
  validateSearch: bookmarksSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_VALUES)],
  },
})
